import { useEffect, useState } from 'react';
import { dbPost } from '../../apis/commonApi';
import { useGlobalStore } from '../contexts';

const SelectEnt = ({ model, valueObj, valueChange }) => {
  const { store } = useGlobalStore();
  const [optionList, setOptionList] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');

  const init = async () => {
    let response;

    try {
      response = await dbPost('/common/ent/list.do', {});

      if (response instanceof Error) {
      } else {
        setOptionList(response);

        const hasMatchingEntSn = response.some(
          option => option.entSn === store.entSn
        );

        if (hasMatchingEntSn) {
          setSelectedValue(valueObj[model]);
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <label className="hidden-label" htmlFor="selectEnt">
        기업선택
      </label>
      <select
        id="selectEnt"
        className="form-select md"
        value={selectedValue}
        onChange={e => {
          setSelectedValue(e.target.value);
          valueChange(model, e.target.value);
        }}
      >
        <option value="">선택</option>
        {optionList.map((option, index) => {
          return (
            <option key={index} value={option.entSn}>
              {option.entNm}
            </option>
          );
        })}
      </select>
    </>
  );
};

export default SelectEnt;
